<ng-container *transloco="let translate;">
    <angular-editor class="custom-editor" [dir]="dir" [formControl]="control" [placeholder]="placeholder" name="name" [title]="title || ''" [id]="id" [class]="id" [config]="editorConfig" (keypress)="errors && errors.splice(0,1);">
        <ng-template *ngIf="enableEncryptDecrypt" #customButtons>
            <ae-toolbar-set class="inline-block float-right mt-px">
                <button
                        class="angular-editor-button showHideActions"
                        [ngClass]="{'active': showToolbar}"
                        title="Show/Hide Actions"
                        (click)="showFormatToolbar()">

                    <span class="font-icon">A</span>
                </button>
            </ae-toolbar-set>
        </ng-template>
    </angular-editor>
    <mat-hint align="end" *ngIf="maxLength" [textContent]="(control.value && control.value.length || 0) + ' / ' + maxLength"></mat-hint>
    <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0)">
        <strong><span>* </span><span [textContent]="translate('Required')"></span></strong>
    </mat-hint>
    <mat-hint align="start" *ngIf="!required && !(errors && errors.length > 0) && hint && hint.length > 0">
        <span [textContent]="hint"></span>
    </mat-hint>
    <mat-error *ngIf="errors && errors.length > 0" [title]="errors">
        <span [textContent]="errors"></span>
    </mat-error>
</ng-container>
